import {Municipality} from '../../municipalities/municipality/municipality';
export class School {
  municipality: Municipality;
  id: string;
  name: string;
}
